'use client';

import { useParams } from 'next/navigation';
import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from '@/contexts/InAppProvider';
import { SectionPage } from 'app/(appHeader)/sections/contests/[contestId]/fancy-share/SectionPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  const params = useParams();
  const contestId = params?.contestId ?? '';
  return <SectionPage contestId={Number(contestId)} isApp={isApp} />;
}
